import React, { useState } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    ReferenceInput,
    AutocompleteInput,
    FormDataConsumer,
    SelectInput,
    required,
    email,
    regex,
} from 'react-admin';
import {UserRoles} from '../common.js'
import { AdminUserRoles } from '../../../../constants/user.js';

const UsersCreate = (props) => {
    const [role, setRole] = useState(null);

    return (
        <Create {...props} redirect={"show"}  >
            <SimpleForm >
                <TextInput source="name" validate={[required()]}/>
                <TextInput source="surname" validate={[required()]}/>
                <TextInput source="email" validate={[required(), email()]}/>
                <TextInput source="password" type="password" validate={[required(), regex(/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$€%^&*(),.?":{}|<>_-])(?=.{12,})/, 'La contraseña debe tener mínimo 12 caracteres y debe incluir una combinación de mayúsculas, minúsculas, números y caracteres especiales.')]} />
                <FormDataConsumer>
                    {// eslint-disable-next-line no-unused-vars
                        ({ formData }) => (
                            <>
                                <div className="child-items">
                                    <SelectInput source="admin_user.role" validate={[required()]} choices={UserRoles} onChange={(item) => {
                                        if (item && item.target && item.target.value) {
                                            setRole(item.target.value);
                                        }
                                    }} />
                                </div>
                            </>
                        )}
                </FormDataConsumer>
                {role && role !== AdminUserRoles.ROLE_ADMIN_ROOT && <ReferenceInput
                    source="client.id"
                    reference="clients"
                    sort={{field: 'name', order: 'ASC'}}
                    perPage={1000}
                >
                    <AutocompleteInput
                        source="name"
                        optionText="name"
                        filterToQuery={(searchText) => ({ name: searchText})}
                    />
                </ReferenceInput>}
            </SimpleForm>
        </Create>
    )
}

export default UsersCreate;